import { init as initHeader } from './header/header';
import { init as initNavigation } from './navigation/navigation';
import { init as initInternalSearch } from './header/search/search';
import { init as initRecoWoosmap } from './header/recowoosmap';
import { init as initCubeLibraries } from './lib-cube';
// Import analytics
import { init as initAnalytics } from '../analytics/routes/common.anly.route';

// Specific spain : testing the new search engine
// TODO : clean and refactor this after the spain has made a decision
import { initSearchSpain } from '@/search-spain/search-spain.entry';

export const init = () => {
  // Init / Extends `cube.*` lib
  initCubeLibraries();

  // Layout - Header
  initHeader();

  //SPECIFIC SPAIN, see comment above
  if (cube.$('.js-custom-search-spain')) {
    initSearchSpain();
  } else if (cube.$('.l-search-form')) {
    initInternalSearch();
  }

  // Navigation
  initNavigation();

  // General - Iframes
  loadIframes();

  //if use Store recommandation is enabled
  const headerStore = cube.$id('header-store');
  if (headerStore) {
    const useStoreRecommendation = headerStore.dataset.storeRecommendation;
    if (useStoreRecommendation === 'true') {
      if (window.tc_vars.env_country !== 'CN' && !cube.$('.has--store')) {
        initRecoWoosmap();
      }
    }
  }

  // Initialize Analytics
  try {
    if (window.cube.config.anly_useLegacy === 'Y') {
      initAnalytics();
    }
  } catch (error) {
    console.error(`Common analytics init failed : ${error}`);
  }


  if (cube.$id('js-chatbot-loader-placeholder'))
    import(
      /* webpackChunkName: "chatbot-loader" */ './component/chatbot-loader/chatbot-loader'
    ).then(({ init: initChatbot }) => initChatbot());
};

const loadIframes = () => {
  // Load the iframes by setting 'src' from 'url' attribute
  $('iframe').each((i, iframe) => {
    if (iframe.dataset.url) iframe.setAttribute('src', iframe.dataset.url);
  });
};



// WEBPACK FOOTER //
// ./src/commons/commons.entry.js